import { render, staticRenderFns } from "./SpeakerSegmentTranscript.vue?vue&type=template&id=12446b1e&scoped=true&"
import script from "./SpeakerSegmentTranscript.vue?vue&type=script&lang=ts&"
export * from "./SpeakerSegmentTranscript.vue?vue&type=script&lang=ts&"
import style0 from "./SpeakerSegmentTranscript.vue?vue&type=style&index=0&id=12446b1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12446b1e",
  null
  
)

export default component.exports